import type { LetterboxedFrame } from "./pose";
import type { ViewRect } from "../shared/geometry";

/** Identical nearest-pixel choices for CPU and GPU, including exact half-pixel ties. */
export function thumbnailIndices(
  frame: LetterboxedFrame,
  quad: Float32Array,
  area: ViewRect,
  width: number,
  height: number,
): Uint32Array<ArrayBuffer> {
  const cx = new Float32Array(4),
    cy = new Float32Array(4);
  for (let k = 0; k < 4; k++) {
    cx[k] = (quad[k * 2] - area.x) * frame.scale + frame.left;
    cy[k] = (quad[k * 2 + 1] - area.y) * frame.scale + frame.top;
  }
  const indices = new Uint32Array(256);
  for (let row = 0; row < 16; row++)
    for (let col = 0; col < 16; col++) {
      const u = 0.12 + (0.76 * (col + 0.5)) / 16,
        v = 0.12 + (0.76 * (row + 0.5)) / 16;
      const topX = cx[0] + (cx[1] - cx[0]) * u,
        topY = cy[0] + (cy[1] - cy[0]) * u;
      const bottomX = cx[3] + (cx[2] - cx[3]) * u,
        bottomY = cy[3] + (cy[2] - cy[3]) * u;
      const x = Math.min(width - 1, Math.max(0, Math.round(topX + (bottomX - topX) * v)));
      const y = Math.min(height - 1, Math.max(0, Math.round(topY + (bottomY - topY) * v)));
      indices[row * 16 + col] = y * width + x;
    }
  return indices;
}
